import type React from 'react'

// ── Styles ─────────────────────────────────────────────────────────────────────
export const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '11px 18px',
  borderBottom: '1px solid var(--border)',
  textDecoration: 'none',
  transition: 'background 0.1s',
}

